import Component from '../../Components/Sidebar_Component/Component';
import { Authorization } from '../../providers/AuthContextProvider';
import React, { useContext } from 'react';
import { profileRoutes } from '../../lib/profileRoutes';
import withAuth from '../../Components/withAuth';

const Profile = ({ route }) => {
    const { user } = useContext(Authorization)

    return (
        <>
            <><title>پنل شخصی</title></>
            {!!Object.keys(user)?.length ? <main>
                <div className="my-12 min-h-screen" dir='rtl'>
                    <div className="container">
                        <Component page='profile' links={profileRoutes} query={route}>
                            <div className='flex justify-end items-center py-4 mx-4'>
                                <div className='w-12 h-12'>
                                    <img width={100} height={100} className='w-full h-full object-cover' src={'/images/Ei-user.svg'} alt="" />
                                </div>
                                <div className='mr-4 grow flex flex-col'>
                                    <p className=''>{user?.first_name} {user?.last_name}</p>
                                    <span className='text-sm text-gray-700'>{user?.mobile || user?.email}</span>
                                </div>
                            </div>
                        </Component>
                    </div>
                </div>
            </main> : 'لطفا وارد حساب کاربری خود شوید'}
        </>
    );
};

export default withAuth(Profile);